export default {"src":"/_next/static/media/410.b2653ed1.svg","height":390,"width":650,"blurWidth":0,"blurHeight":0};